// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--DsA7r"};